// 9fbef606107a605d69c0edbcd8029e5d
import { BUNDLEPRODUCT_ACTION_PATTERN } from '../../../../../constants/reducer.constants';

const SET_BUNDLE_DETAILS = `${BUNDLEPRODUCT_ACTION_PATTERN}SET_BUNDLE_DETAILS`;
const FETCH_BUNDLE_DETAILS = `${BUNDLEPRODUCT_ACTION_PATTERN}FETCH_BUNDLE_DETAILS`;
const SET_BUNDLE_PRODUCTS_DETAILS = `${BUNDLEPRODUCT_ACTION_PATTERN}SET_BUNDLE_PRODUCTS_DETAILS`;
const CLEAR_BUNDLE_DETAILS = `${BUNDLEPRODUCT_ACTION_PATTERN}CLEAR_BUNDLE_DETAILS`;
const SET_ADD_TO_FAVORITE = `${BUNDLEPRODUCT_ACTION_PATTERN}SET_ADD_TO_FAVORITE`;
const SET_LOADING_STATE = `${BUNDLEPRODUCT_ACTION_PATTERN}SET_LOADING_STATE`;
const SET_PAGE_URL = `${BUNDLEPRODUCT_ACTION_PATTERN}SET_PAGE_URL`;
const GET_IN_YOUR_BAG_PRODUCT_COUNT = `${BUNDLEPRODUCT_ACTION_PATTERN}GET_IN_YOUR_BAG_PRODUCT_COUNT`;
const SET_IN_YOUR_BAG_COUNT = `${BUNDLEPRODUCT_ACTION_PATTERN}SET_IN_YOUR_BAG_COUNT`;
const SET_IS_BUNDLE = `${BUNDLEPRODUCT_ACTION_PATTERN}SET_IS_BUNDLE`;
const CARRY_FORWARD_IMG_URL = `${BUNDLEPRODUCT_ACTION_PATTERN}CARRY_FORWARD_IMG_URL`;
const CALL_ITEMS_IN_BAG = `${BUNDLEPRODUCT_ACTION_PATTERN}CALL_ITEMS_IN_BAG`;
const SET_DEPARTMENT_BUNDLE_PRODUCTS = `${BUNDLEPRODUCT_ACTION_PATTERN}SET_DEPARTMENT_BUNDLE_PRODUCTS`;
const FETCH_SELECTED_FIT_PRODUCT = `${BUNDLEPRODUCT_ACTION_PATTERN}FETCH_SELECTED_FIT_PRODUCT`;
const UPDATE_BUNDLE_PRODUCT_ITEM = `${BUNDLEPRODUCT_ACTION_PATTERN}UPDATE_BUNDLE_PRODUCT_ITEM`;

const BUNDLEPRODUCT_CONSTANTS = {
  SET_BUNDLE_DETAILS,
  FETCH_BUNDLE_DETAILS,
  SET_BUNDLE_PRODUCTS_DETAILS,
  CLEAR_BUNDLE_DETAILS,
  SET_ADD_TO_FAVORITE,
  SET_LOADING_STATE,
  SET_PAGE_URL,
  GET_IN_YOUR_BAG_PRODUCT_COUNT,
  SET_IN_YOUR_BAG_COUNT,
  SET_IS_BUNDLE,
  CARRY_FORWARD_IMG_URL,
  CALL_ITEMS_IN_BAG,
  SET_DEPARTMENT_BUNDLE_PRODUCTS,
  FETCH_SELECTED_FIT_PRODUCT,
  UPDATE_BUNDLE_PRODUCT_ITEM,
};

export default BUNDLEPRODUCT_CONSTANTS;
